import DateUtils from 'portaltransparencia-common/libs/DateUtils.js';
import PropTypes from 'prop-types';
import React from 'react';
import Component from 'react-pure-render/component';
import { connect } from 'react-redux';

import * as actions from './Actions.js';
import Hint from 'portaltransparencia-common/components/hint/Hint.react';

export class FormUltimaAtualizacaoByTable extends Component {
  static propTypes = {
    modulo: PropTypes.string.isRequired,
    table: PropTypes.string.isRequired,
    column: PropTypes.string.isRequired,
    moduloComparativo: PropTypes.string,
    tableComparativo: PropTypes.string,
    columnComparativo: PropTypes.string,
    comparativo: PropTypes.string.isRequired,
    ultimaAtualizacaoByTable: PropTypes.object.isRequired,
    ultimaAtualizacaoByTableComparativo: PropTypes.object.isRequired,
    findUltimaAtualizacaoByTable: PropTypes.func.isRequired,
    filtrarEntidade: PropTypes.bool,
    dateAtt: PropTypes.string,
    isIntegradoOxy: PropTypes.bool
  };

  static defaultProps = {
    modulo: '3',
    column: 'dataultimaatualizacao',
    comparativo: 'N',
    filtrarEntidade: false,
    dateAtt: null
  };

  componentDidMount() {
    const {
      findUltimaAtualizacaoByTable,
      modulo,
      table,
      column,
      comparativo,
      moduloComparativo,
      tableComparativo,
      columnComparativo,
      filtrarEntidade,
      dateAtt
    } = this.props;

    findUltimaAtualizacaoByTable(
      modulo,
      table,
      column,
      'N',
      filtrarEntidade,
      dateAtt
    );

    if (comparativo == 'S') {
      findUltimaAtualizacaoByTable(
        moduloComparativo,
        tableComparativo,
        columnComparativo,
        comparativo,
        filtrarEntidade,
        dateAtt
      );
    }
  }

  getDataContabilAndOrcamento = function (
    dateAtt,
    isIntegradoOxy,
    ultimaAtualizacaoByTable
  ) {
    if (isIntegradoOxy && dateAtt) {
      return DateUtils.formatDateTime(dateAtt, 'DD/MM/YYYY HH:mm:ss');
    } else {
      const date =
        ultimaAtualizacaoByTable.get('ultimoAcesso') ??
        DateUtils.formatDateTime(new Date());
      return DateUtils.formatDateTime(date, 'DD/MM/YYYY HH:mm:ss');
    }
  };

  render() {
    const {
      ultimaAtualizacaoByTable,
      modulo,
      comparativo,
      ultimaAtualizacaoByTableComparativo,
      dateAtt,
      isIntegradoOxy
    } = this.props;
    let date, dateComparativo;

    if (modulo == 3 || modulo == 14) {
      date = this.getDataContabilAndOrcamento(
        dateAtt,
        isIntegradoOxy,
        ultimaAtualizacaoByTable
      );
    } else {
      date = DateUtils.formatDateTimeShort(
        ultimaAtualizacaoByTable.get('ultimoAcesso')
      );
    }

    if (comparativo == 'S') {
      if (modulo == 3 || modulo == 14) {
        dateComparativo = DateUtils.formatDateTime(
          ultimaAtualizacaoByTableComparativo.get('ultimoAcesso'),
          'DD/MM/YYYY HH:mm:ss'
        );
        if (!dateComparativo) {
          dateComparativo = DateUtils.formatDateTime(new Date());
        }
      } else {
        dateComparativo = DateUtils.formatDateTimeShort(
          ultimaAtualizacaoByTableComparativo.get('ultimoAcesso')
        );
      }

      if (
        ultimaAtualizacaoByTableComparativo.get('ultimoAcesso') >=
        ultimaAtualizacaoByTable.get('ultimoAcesso')
      ) {
        date = dateComparativo;
      }
    }

    return (
      <div className="last-updated" id="datetime">
        <i className="fa fa-clock-o"></i> Última Atualização: {date}
        {date && (
          <span style={{ marginLeft: '6px' }}>
            <Hint
              message="A hora exibida considera o horário de Brasília (GMT -3)"
              isInline
              position="left"
              size="sm"
              icon="fa fa-info-circle"
              spacing=""
            ></Hint>
          </span>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ultimaAtualizacaoByTable: state.ultimaAtualizacao.get(
      'ultimaAtualizacaoByTable'
    ),
    ultimaAtualizacaoByTableComparativo: state.ultimaAtualizacao.get(
      'ultimaAtualizacaoByTableComparativo'
    ),
    isIntegradoOxy: state.entidade.getIn([
      'configuracoesGerais',
      'isIntegradoOxy'
    ])
  };
}

export default connect(mapStateToProps, actions)(FormUltimaAtualizacaoByTable);
